import * as React from "react";
import * as CheckboxModule from "@mui/material/Checkbox/index.js";
import * as FormControlModule from "@mui/material/FormControl/index.js";
import * as FormControlLabelModule from "@mui/material/FormControlLabel/index.js";
import * as FormGroupModule from "@mui/material/FormGroup/index.js";
import * as FormHelperTextModule from "@mui/material/FormHelperText/index.js";
import * as FormLabelModule from "@mui/material/FormLabel/index.js";
import { resolveDefault } from "../../utils/moduleInterop";

const Checkbox = resolveDefault<any>(CheckboxModule);
const FormControl = resolveDefault<any>(FormControlModule);
const FormControlLabel = resolveDefault<any>(FormControlLabelModule);
const FormGroup = resolveDefault<any>(FormGroupModule);
const FormHelperText = resolveDefault<any>(FormHelperTextModule);
const FormLabel = resolveDefault<any>(FormLabelModule);

interface CheckboxFieldProps {
	label?: string;
	name: string;
	options?: string[];
	error?: any;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	setFieldValue: (name: string, value: string) => void;
	value?: string;
	handleBlur?: () => void;
	disabled?: boolean;
	helperText?: string;
}

const CheckboxField: React.FC<CheckboxFieldProps> = ({
	label = "Checkbox",
	name = "",
	options = ["Option 1", "Option 2"],
	error = "",
	onChange,
	setFieldValue,
	value,
	handleBlur,
	disabled,
	helperText = "Helper text",
}) => {
	const [checkedItems, setCheckedItems] = React.useState<string[]>([]);

	React.useEffect(() => {
		if (value) {
			setCheckedItems(value.split("NA&&"));
		}
	}, [value]);

	const handleCheckItem = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = e.target;
		let items = [...checkedItems];

		if (items.includes(value)) {
			items = items.filter((item) => item !== value);
		} else {
			items.push(value);
		}
		setCheckedItems(items);
		setFieldValue(name, items.join("NA&&"));
	};

	const isChecked = (option: string) => checkedItems.includes(option);

	return (
		<FormControl component="fieldset" variant="standard">
			<FormLabel component="legend">{label}</FormLabel>
			<FormGroup>
				{options.map((opt, index) => (
						<FormControlLabel
							key={index}
							control={
								<Checkbox
									checked={isChecked(opt)}
									onChange={handleCheckItem}
								name={`${name}-${index}`}
								onBlur={handleBlur}
									value={opt}
									color="primary"
								disabled={disabled}
									size="small"
								/>
							}
							label={opt}
						/>
				))}
				<FormHelperText>{helperText}</FormHelperText>
				<FormHelperText error={!!error}>{error}</FormHelperText>
			</FormGroup>
		</FormControl>
	);
};

export default CheckboxField;
